import { Shield, Quote } from "lucide-react";

export default function LawEnforcement() {
  return (
    <section
      id="law-enforcement"
      data-testid="law-enforcement-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-[#262626] overflow-hidden"
    >
      {/* Subtle blue overlay for first responder tone */}
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 80% 20%, rgba(20, 80, 180, 0.5) 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">FIRST RESPONDERS · LAW ENFORCEMENT</span>
          <div className="divider-red" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: Heading + context */}
          <div className="lg:col-span-5">
            <div className="bg-[#EC1985] p-4 inline-block mb-6">
              <Shield size={28} className="text-white" />
            </div>
            <h2 className="h-display text-5xl md:text-6xl lg:text-7xl text-white">
              Speaking to the<br />
              <span className="text-[#EC1985]">hearts</span> of those<br />
              who serve.
            </h2>
            <p className="mt-8 text-white/75 text-lg leading-relaxed max-w-md">
              Gary's work with law enforcement, corrections leadership,
              highway patrol, and first responders is a calling — bringing
              renewed purpose to those who carry the weight of protecting
              everyone else.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {[
                "CDCR Executive Leadership",
                "Pelican Bay State Prison",
                "Folsom State Prison",
                "CALIBRE Press",
                "TASRO",
                "Virginia Highway Patrol",
                "Virginia DMV",
                "National Jail Association",
              ].map((c) => (
                <span
                  key={c}
                  className="text-xs uppercase tracking-[0.15em] font-bold border border-[#262626] px-3 py-2 text-white/85"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>

          {/* Right: Featured quote */}
          <div className="lg:col-span-7">
            <article
              data-testid="ralph-diaz-quote"
              className="surface p-8 md:p-12 relative border-[#EC1985]/30"
            >
              <Quote size={48} className="text-[#EC1985] opacity-50 mb-6" />
              <blockquote className="space-y-5 text-white text-lg md:text-xl leading-relaxed">
                <p>
                  "In my 30 years of public safety, it is hard to find
                  individuals who can reach and inspire our men and women
                  of law enforcement. Gary has a unique ability to{" "}
                  <span className="text-[#EC1985] font-bold">
                    speak life
                  </span>{" "}
                  into those who dedicate themselves to protect us all."
                </p>
                <p className="text-white/80">
                  "There are times when it takes someone who has never worn
                  a law enforcement uniform to speak into the hearts of
                  those who serve us all. We are in different times today."
                </p>
                <p className="text-white">
                  "Gary can speak to the hearts of those that are hurting
                  and{" "}
                  <span className="text-[#EC1985] font-bold">
                    uplift them and restore their purpose
                  </span>
                  ."
                </p>
              </blockquote>

              <div className="mt-10 pt-6 border-t border-[#262626]">
                <div className="text-lg font-bold text-white">Ralph Diaz</div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-white/60 font-bold">
                  Former CDCR Secretary
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-[#EC1985] font-bold">
                  California Department of Corrections & Rehabilitation
                </div>
              </div>
            </article>

            <div className="mt-6 text-xs uppercase tracking-[0.2em] text-white/40 font-bold">
              ★ Additional law enforcement endorsement letters available on request
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
